module.exports = __webpack_public_path__ + "static/media/Sparse-Ahmed-Mostafa-vetarans-2.e7afccc4.jpg";